import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'gpe-binocular',
  templateUrl: './binocular.component.svg',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BinocularComponent { }
